import { render, staticRenderFns } from "./QuizStudentDescription.vue?vue&type=template&id=5e31914a&"
import script from "./QuizStudentDescription.vue?vue&type=script&lang=js&"
export * from "./QuizStudentDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports